module.exports = __webpack_public_path__ + "img/invite-bg-zh.53fe9886.png";